export const TIMELINE_SCALE_STEPS = [2, 4, 8] as const
export type TimelineScaleStep = (typeof TIMELINE_SCALE_STEPS)[number]
export const DEFAULT_PX_PER_MINUTE: TimelineScaleStep = 4

export const MIN_CARD_MINUTES = 15
export const ABSOLUTE_MIN_CARD_PX = 40
export const TIMELINE_PADDING_TOP = 20
export const TIMELINE_PADDING_BOTTOM = 20
export const TIME_LABEL_WIDTH = 50

// NOTE: theme.jsと重複しているがtheme.jsを今後使わない方針になりそうなため、SpBerthManagement内で完結させるために定義している
export const COLORS = {
  blue: '#247CDB',
  lightBlue: '#93C7FF',
  red: '#DB2464',
  green: '#17BEBB',
  orange: '#EF8A67',
  pink: '#F1A7C1',
  white: '#FFFFFF',
  gray: '#A8A9AB',
  darkGray: '#424242',
  lightGray: '#9E9E9E',
} as const

export const GENERAL_BOOKING_WAITING_STATUS = {
  NEXT: 0,
  SECOND: 1,
  LATER: 2,
} as const

export const CALLING_DURATION_OPTIONS = [5, 10, 15, 20, 25, 30, 60, 90, 120] as const
